export default __webpack_public_path__ + "static/media/Xu Yuan Packaging.1fe90cbc.png";